import { padLeft } from "../string";
import { TWO_WEEKS } from "./constants";

// TO BE REVIEWED
// Replace with startOfDayUTC?
export function convertToDateTimeString(
  date: string | Date = new Date(),
): string {
  if (typeof date === "object") {
    return `${date.getFullYear()}-${padLeft(date.getMonth() + 1)}-${padLeft(
      date.getDate(),
    )}T00:00:00Z`;
  }

  return date.includes("T") ? date : `${date}T00:00:00Z`;
}

export function startOfDayUTC(value = new Date()): Date {
  return new Date(new Date(value).setUTCHours(0, 0, 0, 0));
}

export function normalize(date: Date | string | number): Date {
  if (typeof date === "string" || typeof date === "number") {
    date = new Date(date);
  }

  // invalidate date
  if (date.toString() === "Invalid Date") {
    throw new Error("Invalid Date");
  }

  return new Date(date.getTime());
}

export function setDate(
  date: Date | string | number,
  set: Date | string | number,
): Date {
  const dateCopy = normalize(date);
  const setCopy = normalize(set);

  return new Date(
    setCopy.getFullYear(),
    setCopy.getMonth(),
    setCopy.getDate(),
    dateCopy.getHours(),
    dateCopy.getMinutes(),
    dateCopy.getSeconds(),
    dateCopy.getMilliseconds(),
  );
}

export function setHoursMinutes(
  date: Date | string | number,
  time: Date | string | number,
): Date {
  const dateCopy = normalize(date);
  const timeCopy = normalize(time);

  dateCopy.setHours(timeCopy.getHours());
  dateCopy.setMinutes(timeCopy.getMinutes());

  return dateCopy;
}

export function resetHoursMinutes(date: Date | string | number): Date {
  const dateCopy = normalize(date);
  dateCopy.setHours(0);
  dateCopy.setMinutes(0);

  return dateCopy;
}

export function addDays(date: Date | string | number, offset: number): string {
  const formattedDate = normalize(date);
  const newDate = new Date(
    formattedDate.setDate(formattedDate.getDate() + offset),
  );
  return newDate.toISOString();
}

export function addMonths(
  date: Date | string | number,
  offset: number,
): string {
  const formattedDate = normalize(date);
  const newDate = new Date(
    formattedDate.setMonth(formattedDate.getMonth() + offset),
  );
  return `${newDate.toISOString().split("T")[0]}T12:00:00Z`;
}

export function getISODateWithOffset(
  date?: Date | string | number,
  offset = TWO_WEEKS,
): string {
  const time = date ? normalize(date).getTime() : Date.now();
  const newDate = new Date(time + offset);
  return `${newDate.toISOString().split("T")[0]}T12:00:00Z`;
}
